<graph [nodes]="nodes" [links]="links"></graph>